import { render, staticRenderFns } from "./note-history.vue?vue&type=template&id=179d7e1c&"
import script from "./note-history.vue?vue&type=script&lang=js&"
export * from "./note-history.vue?vue&type=script&lang=js&"
import style0 from "./note-history.vue?vue&type=style&index=0&id=179d7e1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports